import { SITE_URL } from "../config/site";
export default function ProductStructuredData({ product }) {
  if (!product) return null;

 const url = `${SITE_URL}/producto/${product.slug || product.id}`;

const imageUrl = product.image
  ? `${SITE_URL}${product.image}`
  : undefined;
  
  const description =
    product.seo?.description ||
    product.shortDescription ||
    product.description ||
    "Producto personalizado de Imalandia.";

  const data = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: product.name,
    description,
    image: imageUrl,
    brand: {
      "@type": "Brand",
      name: "Imalandia",
    },
    offers: {
      "@type": "Offer",
      url,
      priceCurrency: product.currency || "EUR",
      price: product.price,
      availability: product.active
        ? "https://schema.org/InStock"
        : "https://schema.org/OutOfStock",
    },
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(data)}
    </script>
  );
}